import { render, staticRenderFns } from "./preguntasSingle.vue?vue&type=template&id=b725ae80&scoped=true&"
import script from "./preguntasSingle.vue?vue&type=script&lang=js&"
export * from "./preguntasSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b725ae80",
  null
  
)

export default component.exports